module.exports = __webpack_public_path__ + "static/forms-layout-do-c072811fcfc805f9547e34ecaa63ecb7.png";